import { WifiStandardEnum } from '@ubnt/link-core/enums';
import { memo, useMemo } from 'react';
import Icon, { type IconProps } from '@ubnt/ui-components/Icon/Icon';
import Wifi4 from 'icons/Wifi4.svg';
import Wifi5 from 'icons/Wifi5.svg';
import Wifi6 from 'icons/Wifi6.svg';
import Wifi7 from 'icons/Wifi7.svg';
import SuperLink from 'icons/SuperLink.svg';
import BluetoothLE from 'icons/BluetoothLE.svg';
import COLORS from 'styles/colors.module.scss';
import { useApplicationStore } from 'modules/application/store';

export interface WifiStandardIconProps extends IconProps {
  wifiStandard: ValuesOf<typeof WifiStandardEnum>;
}

const WifiIconByStandard = {
  [WifiStandardEnum.Wifi4]: Wifi4,
  [WifiStandardEnum.Wifi5]: Wifi5,
  [WifiStandardEnum.Wifi6]: Wifi6,
  [WifiStandardEnum.Wifi6E]: Wifi6,
  [WifiStandardEnum.Wifi7]: Wifi7,
  [WifiStandardEnum.SuperLink]: SuperLink,
  [WifiStandardEnum.BLE]: BluetoothLE,
};

const WifiStandardIcon = (props: WifiStandardIconProps) => {
  const { wifiStandard, ...rest } = props;
  const WifiIcon = WifiIconByStandard[wifiStandard];
  const isMobile = useApplicationStore((state) => state.isMobile);
  const size = useMemo(() => {
    if (isMobile) {
      return undefined;
    }
    return 'original';
  }, [isMobile]);

  if (!WifiIcon) {
    return null;
  }

  return (
    <Icon size={size} color={COLORS.blue06} {...rest}>
      <WifiIcon />
    </Icon>
  );
};

const MemoizedWifiStandardIcon = memo(WifiStandardIcon);

export default MemoizedWifiStandardIcon;
